import React, { Component } from 'react';
import {connect} from  'react-redux';
import { Link } from 'react-router-dom';
import ReactTable from "react-table-v6";
import "react-table-v6/react-table.css";
import TmExportExcel from '../../../../utilComponents/tmExportExcel/tmExportExcel';
import {utilMethods} from '../../../../../util/util';
class AccountByDepartmentDetails extends Component {
    constructor() {
        super();
        this.state = {
            excelDataSet:[]
        };
        this.buildDataFormatForExport=this.buildDataFormatForExport.bind(this);
      }
      componentWillMount=()=>{
        this.setState({excelDataSet:this.props.adminDashboard_All_Accounts.filter(item => item.isActive === 1)});
      }
      componentWillReceiveProps=(nextProps)=>{
        this.setState({excelDataSet:nextProps.adminDashboard_All_Accounts.filter(item => item.isActive === 1)});
      }
      buildDataFormatForExport=()=>{
        return([{
          columns:[{title:'Account Name'},{title:'Account Type'}],
          data: this.state.excelDataSet.map((item)=>{
            return [{value:item.accountName || ''},{value:item.accountType || ''}]
          })
        }])
      }
    render() {
        const { adminDashboard_All_Accounts } = this.props;
        return (
          <>
          <div className="page-header">
                <div className="row mb-10">
                    <div className="col-md-12 col-sm-12">
                        <div className="title">
                        <h4><i className="fa fa-building-o"></i> Account By Department Accounts</h4>
                        </div>
                    </div>
                </div>
            </div>
             <div className="pd-10 bg-white border-radius-4 box-shadow container-box">
             <div className="row">
                  <div className="col-md-12 col-sm-12 mb-10">
                    <div>
                    <Link class="btn btn-info" to="/admin-dashboard"><i class="fa fa-arrow-left" aria-hidden="true"></i> Back </Link>
                    <TmExportExcel name={'Account By Department Accounts'} filename={'Account_By_Dept_Accounts'} 
                    element={<button className="btn btn-warning btn-sm pull-right"><i className="fa fa-file-excel-o"></i> Export</button>}
                    dataSet={this.buildDataFormatForExport()} />
                    </div>
                    </div>
                    </div>
            <div className="row">
                <div className="col-md-12">
                <ReactTable ref={(t)=>this.expiryTable=t}
                        data={adminDashboard_All_Accounts.filter(item => item.isActive === 1)}
                        columns={[
                            {
                                Header:'Account Name',
                                accessor:'accountName'
                            },
                            {
                                Header:'Account Type',
                                accessor:'accountType',
                                filterable: true,
                                Cell: props => <a className="" href="javascript:void(0)">{props.value}</a>,
                                width: 300,
                                Filter: ({ filter, onChange }) =>
                                <select
                                onChange={event => onChange(event.target.value)}
                                style={{ width: "100%" }}
                                value={filter ? filter.value : ""}
                                >
                                <option value=""></option>
                                {
                                    adminDashboard_All_Accounts.reduce((acc, current) => {
                                        const x = acc.find(item => item.accountType === current.accountType);
                                        if (!x) {
                                          return acc.concat([current]);
                                        } else {
                                          return acc;
                                        }
                                      }, []).map((atype, k) => {
                                    return <option key={k} value={atype.accountType}>{atype.accountType}</option>
                                    })
                                }
                                </select>
                            }
                        ]}
                        onFilteredChange={()=>{
                            let disableAccounts=this.expiryTable.getResolvedState().sortedData;
                            this.setState({excelDataSet:disableAccounts});
                          }}
                        defaultPageSize={10}
                        className="-striped -highlight"
                        filterable="true"
                        defaultFilterMethod={(filter, row)=> {
                            const id = filter.pivotId || filter.id;
                            return (
                              row[id] !== undefined ?
                              utilMethods.isNumber(row[id])? (row[id].toString()).includes(filter.value):
                                String(row[id].toLowerCase()).includes(filter.value.toLowerCase())
                              :
                                true
                            )}}
                        />
                </div>  
            </div> 
            </div>   
            </>                                                         
        );
    }
}
const mapStateToProps = (state, ownProps) => {
    return {
        adminDashboard_All_Accounts: state.adminDashboard.allAccounts  
    }
};
export default connect(mapStateToProps)(AccountByDepartmentDetails);